module.exports = __webpack_public_path__ + "static/media/minus-circle.7f04b8dd.svg";